import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { BacksolveApproachAttributes } from 'pages/ValuationsAllocation/types';
import { parseDatabaseValue } from 'utilities';

const WEIGHTING_FIELD_ALIAS = 'weighting';

const parseWeightingValue = (
  weightingCell: ICell | undefined,
  rowWeighting: string | null | undefined,
  fieldAttributes: BacksolveApproachAttributes,
  allowEmptyValues: boolean,
): string => {
  const defaultValue = rowWeighting ?? '0';
  const type = weightingCell?.dbType ?? 'string';
  const format = weightingCell?.format ?? null;
  const value = weightingCell?.value ?? defaultValue;
  const gridType = weightingCell?.gridType;
  const fieldAttributesDecimalPlaces = fieldAttributes[WEIGHTING_FIELD_ALIAS as keyof BacksolveApproachAttributes]
    ?.decimal_places;
  const decimalPlaces = Number(fieldAttributesDecimalPlaces ?? weightingCell?.dbDecimalPlaces);

  return parseDatabaseValue({
    type,
    value,
    format,
    allowEmptyValues,
    gridType: gridType ?? undefined,
    decimalPlaces,
  });
};

export default parseWeightingValue;
